import { LuBook, LuFileText, LuNotebookPen } from "react-icons/lu";
import { JournalAccountData } from "@/pages/journal-account";
import { GeneralJournalData } from "@/pages/general-journal";
import { DailyEggProduction, DailyEggProductionPrint } from "@/pages/daily-egg-production-report";
import { CashFlowMonthlyReport, CashFlowReportPrint } from "@/pages/cash-flow-report";
import { SalesReport, SalesReportPrint } from "@/pages/sales-report";
import { ReceivableReport, ReceivableReportPrint } from "@/pages/receivable-report";
import { PayableReport, PayableReportPrint } from "@/pages/payable-report";
import { CashRecapReport, CashRecapReportPrint } from "@/pages/cash-recap-report";

export const accountingPrintRoutes = [
    {
        path: "/sales-report/print",
        component: <SalesReportPrint />,
    },
    {
        path: "/cash-flow-monthly-report/print",
        component: <CashFlowReportPrint />,
    },
    {
        path: "/daily-egg-production-report/print",
        component: <DailyEggProductionPrint />,
    },
    {
        path: "/receivable-report/print",
        component: <ReceivableReportPrint />,
    },
    {
        path: "/payable-report/print",
        component: <PayableReportPrint />,
    },
    {
        path: "/cash-recap-report/print",
        component: <CashRecapReportPrint />,
    },
];

export const accountingRoutes = {
    title: "ACCOUNTING",
    type: "section",
    items: [
        {
            path: "/journal-account",
            title: "Akun Jurnal",
            icon: <LuBook />,
            permission: "journal-account.view",
            component: <JournalAccountData />,
        },
        {
            path: "/general-journal",
            title: "Jurnal Umum",
            icon: <LuNotebookPen />,
            permission: "general-journal.view",
            component: <GeneralJournalData />,
        },
        {
            title: "Laporan",
            icon: <LuFileText />,
            children: [
                {
                    path: "/cash-flow-monthly-report",
                    title: "Arus Kas Bulanan",
                    permission: "report.cash-flow",
                    component: <CashFlowMonthlyReport />,
                },
                {
                    path: "/sales-report",
                    title: "Penjualan",
                    permission: "report.sales",
                    component: <SalesReport />,
                },
                {
                    path: "/receivable-report",
                    title: "Piutang",
                    permission: "report.receivable",
                    component: <ReceivableReport />,
                },
                {
                    path: "/payable-report",
                    title: "Hutang",
                    permission: "report.payable",
                    component: <PayableReport />,
                },
                {
                    path: "/cash-recap-report",
                    title: "Rekap Kas",
                    permission: "report.cash-recap",
                    component: <CashRecapReport />,
                },
                {
                    path: "/daily-egg-production-report",
                    title: "Produksi Harian Telur",
                    permission: "report.egg-production",
                    component: <DailyEggProduction />,
                },
            ],
        },
    ],
};
